import Typography from '@mui/material/Typography'

import { MultiParagraphProps } from '../../types/ComponentProps'

const MultiParagraph = (props: MultiParagraphProps) => {
  return (
    <>
      {props.text.split('\n').map(
        (paragraph, index) =>
          !!paragraph && (
            <Typography key={index} paragraph {...props.TypographyProps}>
              {paragraph}
            </Typography>
          )
      )}
    </>
  )
}

export default MultiParagraph
